import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import PageAtmosphere from './PageAtmosphere';
import { blogPosts } from './blogPosts';
import './Marketing.css';

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return iso;
  }
}

export default function BlogPage() {
  return (
    <div className="marketing-page marketing-page--atmosphere">
      <Seo
        title="Blog — Productivity & calm focus | 3AM AI"
        description="Essays from 3AM AI on productivity, anxiety as a signal, journaling habits, deep work, and goals that stick — calm mental performance without the noise."
        path="/blog"
      />
      <PageAtmosphere />
      <SiteNav />
      <main>
        <header className="page-hero">
          <div className="page-hero__inner m-animate-in">
            <p className="m-section__label">Blog</p>
            <h1>Productivity with a quieter mind</h1>
            <p>
              Practical writing on focus, mood awareness, and goals — for people who want to get
              things done without burning out.
            </p>
          </div>
        </header>

        <div className="blog-list">
          {blogPosts.map((post, i) => (
            <article
              key={post.slug}
              className={`blog-card m-animate-in m-animate-in--delay-${Math.min(i, 3)}`}
            >
              <div className="blog-card__meta">
                <span>{post.category}</span>
                <span aria-hidden="true">·</span>
                <time dateTime={post.date}>{formatDate(post.date)}</time>
                <span aria-hidden="true">·</span>
                <span>{post.readTime}</span>
              </div>
              <h2>
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <p>{post.description}</p>
              <Link to={`/blog/${post.slug}`} className="blog-card__more">
                Read article →
              </Link>
            </article>
          ))}
        </div>

        <section className="cta-band" aria-labelledby="blog-cta">
          <h2 id="blog-cta">Put the ideas into practice</h2>
          <p>Life Journal helps you write, track moods, set goals, and think with a calm AI coach.</p>
          <div className="m-btn-row">
            <Link to="/signup" className="m-btn m-btn--primary">
              Start free
            </Link>
            <Link to="/product#journey" className="m-btn m-btn--ghost">
              How it works
            </Link>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
